//let dev = "http://localhost:8080";
// let dev = "http://192.168.12.157:8080";
let dev = "https://azc1.node-1.workpoint001.info"; 
//let dev = "https://apiv1.a2zcounsel.com";
let API = dev;
export { API };
